import React, { useEffect, useState } from "react";

// ASSETS

// STYLES
import {
  ProjectsSectionContainer,
  ProjectsSectionWrapper,
  CirclesWrapper,
  ProjectsSectionDescriptionContainer,
  RedContainer,
  ButtonWrapper,
} from "./ManagementSectionStyled";

// LIBRARIES
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

// MISC
import { COLORS } from "constants/variables";
import { TextType } from "components/Atoms/CustomText/CustomTextModel";
import { appRoutes } from "config/AppRoutesConfig";

// REDUX

// COMPONENTS
import CirclesAtom from "components/Atoms/CirclesAtom/CirclesAtom";
import CustomText from "components/Atoms/CustomText/CustomText";
import ButtonAtom from "components/Atoms/ButtonAtom/ButtonAtom";
import { ButtonType } from "components/Atoms/ButtonAtom/ButtonAtomModel";

const ManagementSection = () => {
  // PROPERTIES

  // LIBRARY CONSTANTS
  const navigate = useNavigate();
  const { t } = useTranslation();

  // STATE CONSTANTS
  const colors = {
    firstColor: COLORS.Background + "29",
    secondColor: COLORS.VividAuburn,
  };

  const sizes = ["500px", "400px", "300px", "200px", "100px"];

  // API REQUESTS

  // LIFE CYCLE

  // console.log("documents", documents);

  // EVENT HANDLERS

  return (
    <ProjectsSectionContainer>
      <RedContainer>
        <CirclesWrapper>
          <CirclesAtom
            sizes={sizes}
            colors={colors}
            containerTopPosition={"100%"}
            containerLeftPosition={"35px"}
          />
        </CirclesWrapper>
        <ProjectsSectionWrapper>
          <ProjectsSectionDescriptionContainer>
            <CustomText
              text={t("view.about.management.title")}
              type={TextType.H2}
              color={COLORS.Yellow}
            />
            <CustomText
              text={t("view.about.management.content")}
              type={TextType.P1}
              color={COLORS.Background}
            />
            <ButtonWrapper>
              <ButtonAtom
                text={t("view.about.management.button")}
                type={ButtonType.RedButtonWhiteIcon}
                rightIcon={true}
                onClick={() => navigate(appRoutes.qualityManagement)}
              />
            </ButtonWrapper>
          </ProjectsSectionDescriptionContainer>
        </ProjectsSectionWrapper>
      </RedContainer>
    </ProjectsSectionContainer>
  );
};

export default ManagementSection;
